//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ViewBox, Tabbar, TabbarItem } from 'vux'
import { WHeader } from '@/components/wx'
// SVG 图标
import IconWchat from './icons/wchat'
import IconContact from './icons/contact'
import IconExplore from './icons/explore'
import IconProfile from './icons/profile'

export default {
  name: 'wchat',
  computed: {
    title () {
      return this.$route.meta.title
    },
    pageIndex () {
      return this.$route.meta.tabIndex
    }
  },
  components: {
    ViewBox,
    WHeader,
    Tabbar,
    TabbarItem,

    IconWchat,
    IconContact,
    IconExplore,
    IconProfile
  }
}
